export const accountActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ACCOUNT_INFO: "ACCOUNT_INFO",
  ACCOUNT_CART: "ACCOUNT_CART",
  TOKEN_EXPIRY: "TOKEN_EXPIRY",
  ELECTRONIC_ENTRIES_SUMMARY: "ELECTRONIC_ENTRIES_SUMMARY",
  ORDER_ID: "ORDER_ID",
  AVAILABLE_PROMOS: "AVAILABLE_PROMOS",
  AVAILABLE_PROMOS_LOADING: "AVAILABLE_PROMOS_LOADING",
  AVAILABLE_PROMOS_ERROR: "AVAILABLE_PROMOS_ERROR"
};
